import React from 'react'
import NProgress from 'nprogress'
// views
import { Link as RouterLink, LinkContent } from './views'

type UrlObject = {
  pathname: string
  query?: Record<string, string | string[]>
}

interface LinkProps {
  href: string | UrlObject
  children: React.ReactNode
  [key: string]: any
}

const resolveHref = (href: string | UrlObject): string => {
  if (typeof href === 'string') return href

  const { pathname, query } = href

  if (!query || Object.keys(query).length === 0) {
    return pathname
  }

  const searchParams = new URLSearchParams()

  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else if (value != null) {
      searchParams.set(key, value)
    }
  })

  const qs = searchParams.toString()

  return qs ? `${pathname}?${qs}` : pathname
}

const Link: React.FC<LinkProps> = ({ children, href, onClick, ...rest }) => (
  <RouterLink
    to={resolveHref(href)}
    onClick={(e) => {
      NProgress.start()
      onClick?.(e)
    }}
    {...rest}>
    <LinkContent>{children}</LinkContent>
  </RouterLink>
)

export default Link
